"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var Select_1 = require("@carvana/showroom-forms/Select");

var state_1 = require("../state");

var OptionWrapper = Select_1.SelectStyles.OptionWrapper;

var Option = function (_a) {
  var children = _a.children,
      value = _a.value,
      className = _a.className;

  var _b = react_1.useContext(state_1.AutocompleteContext),
      setIsExpanded = _b.setIsExpanded,
      menuId = _b.menuId,
      selectedValue = _b.selectedValue,
      setSelectedValue = _b.setSelectedValue,
      onSelection = _b.onSelection;

  var isSelected = selectedValue === value;
  var classNames = classnames_1.default({
    'is-selected': isSelected
  }, className);

  var handleOnClick = function () {
    setSelectedValue(value);
    onSelection(value);
    setIsExpanded(false);
  };

  return react_1.default.createElement(OptionWrapper, {
    role: "option",
    onClick: handleOnClick,
    className: classNames,
    "aria-selected": isSelected,
    isAutocomplete: true,
    id: menuId + "_" + value
  }, children);
};

exports.default = Option;